enum DateTimeFormatEnum {
  DEFAULT = 'yyyy/LL/dd',
  FULL = 'yyyy/LL/dd HH:mm:ss',
  MONTH = 'LLLL',
}

export default DateTimeFormatEnum;
